import { APPLY_RECOMMENDATION_SUCCESS } from './actionTypes';

export const applyRecommendationSuccess = campaign => ({
    type: APPLY_RECOMMENDATION_SUCCESS,
    payload: campaign,
});
